import {addCompanySubDomain, getJoinUseInttId, getUser, getUserInfo, isSnsSignUp, isWebView} from "../store.js";
import {getCompanyInfo} from "../../../apiCall/signup/index.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {Header} from "../components/Header.js";
import {ERROR_CODE} from "../constant.js";
import {LoadingPopup} from "../components/popup/LoadingPopup.js";
import {mobileSignIn} from "../../../bridge/renewal-signup/index.js";

async function draw() {
    const joinUseInttId = getJoinUseInttId();
    Mutil.load({type : "circle" , $area : $("body")});
    const companyInfo = await getCompanyInfo(joinUseInttId);
    addCompanySubDomain(companyInfo.SUB_DOM);
    $('body').html(getCompanyInfoTemplate(companyInfo));
    new Header($("#companyInfoSection").find(".js-section-header"), {
        isShowLoginBtn : false,
        isShowPrevBtn : true
    })
    addEvent();
}

function getProfileContents(employeeList = []) {
    if (employeeList.length === 0) {
        return '';
    }
    return employeeList.map((employee) => getProfilePhotoTemplate(employee.PRFL_PHTG))
        .join(" ");
}

function getProfilePhotoTemplate(profilePhotoUrl = '') {
    const defaultImageUrl = "/flow-renewal/assets/images/profile-default.png";
    return `<p class="js-profile user-img" style="background-image: url(${profilePhotoUrl})  , url(${defaultImageUrl}) ;"></p>`
}

function getNameContents(employeeList = []) {
    if (employeeList.length === 0) {
        return '';
    }
    return employeeList.map((employee) => {
        if(Mutil.empty(employee.FLNM)) {
            return '';
        }
        return `<span>${employee.FLNM}</span>`;
    }).join(", ") + ` ${i18next.t(login.participating)}`;
}
function getCompanyInfoTemplate(companyInfo) {
    const {
        USE_INTT_NM = '',
        EMPL_REC = []
    } = companyInfo;
    return `
        <section id="companyInfoSection" class="signup-wide-pop">
           <header class="js-section-header"></header>
           <article>
            <div class="pop-main">
              <h3>${i18next.t(login.confirmCompany)}</h3>
              <p>${i18next.t(login.confirmCompanyDesc)}</p>
        
              <div class="company-info-read-wrap">
                <em>${USE_INTT_NM}</em>
                <div>
                  ${getProfileContents(EMPL_REC)}
                </div>
                <p>
                    ${getNameContents(EMPL_REC)}
                </p>
                <button id="joinCompanyBtn">${i18next.t(common.requestedToJoin)}</button>
              </div>
            </div>
          </article>
        </section>`
}

function signIn(data) {
    if(isWebView()) {
        mobileSignIn({...data?.PASS_JSON})
        return;
    }
    const CommonLogin = Mutil.requireIIFE("CommonLogin");
    CommonLogin.goLogin({...data?.PASS_JSON});
}

function addEvent() {
    $("#joinCompanyBtn").off("click").on("click" , async (e) => {
        const data = await getUser().joinCompanyBySubDom();
        const isJoin = Mutil.n2v(data.ERR_CD) === ERROR_CODE.SUCCESS;
        if(!isJoin) {
            Mutil.toast("error", i18next.t(common.occupy, {val: $t(dictionary.email)}))
            return;
        }
        const isManagerInvited = "Y" === Mutil.n2v(data.JNNG_ATHZ_YN , "N");
        new LoadingPopup($("#companyInfoSection").find("article"), {
            isAppend: true,
        });

        if(isManagerInvited) {
            signIn(data);
            return;
        }
        SignUpViewChanger.loadCompanyJoinWaitView();
    })
}

export const CompanyInfoView = {
    draw
}